import script from "./GoalInfoPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoalInfoPanel.vue?vue&type=script&setup=true&lang=ts"

import "./GoalInfoPanel.vue?vue&type=style&index=0&id=6f2b4622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f2b4622"]])

export default __exports__